import { alpha, Button, Stack, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { Check as CheckIcon } from "@mui/icons-material";
import { copyToClipboard } from "~/lib/clipboard";
import { capitalizeFirstLetter } from "~/lib/helpers";

type TagButton = {
  key: string;
  value?: string | null | undefined;
  displayValue?: string;
};

export type TagButtonProps = {
  item: TagButton;
};

export function TagButton({ item }: TagButtonProps) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = async () => {
    if (item.value) {
      await copyToClipboard(item.value);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 800);
    }
  };

  const tooltipTitle = item.displayValue
    ? `${item.value} (Click to copy)`
    : "Click to copy";

  return (
    <Tooltip placement="top" title={isCopied ? "Copied!" : tooltipTitle} arrow>
      <Stack
        component={Button}
        onClick={handleCopyClick}
        direction="row"
        spacing={0.5}
        aria-label="Copy to clipboard"
        sx={(theme) => ({
          py: 0.5,
          px: 1,
          background: alpha(theme.palette.primary.main, 0.2),
          borderRadius: 1,
          textTransform: "unset",
          "& .MuiTypography-root": {
            fontSize: 12,
            lineHeight: "16px",
          },
        })}
      >
        <Typography
          sx={(theme) => ({
            color: alpha(theme.palette.text.primary, 0.66),
          })}
        >
          {capitalizeFirstLetter(item.key)}
        </Typography>
        <Typography fontWeight={700} sx={{ wordBreak: "break-all", ml: 1 }}>
          {item.displayValue || item.value}
        </Typography>

        {isCopied && (
          <CheckIcon
            fontSize="small"
            sx={{
              ml: 0.5,
              color: "success.main",
              fontSize: 14,
            }}
          />
        )}
      </Stack>
    </Tooltip>
  );
}
